export default {};



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/resources/Test/index.ts